import React from 'react';
import { ResponsivePie } from '@nivo/pie';
import { SystemText } from 'e4shared';
import CustomToolTip from '../_tooltip';

const Chart = ({ data, metric, item, id }) => {
    const [controlHeight, setControlHeight] = React.useState(0);
    const loaded = React.useRef(null);

    React.useEffect(() => {
        const controlHeightGenerator = () => {
            const extrasHeight = 0;
            const me = document.querySelector(`#${id}`);
            let result = me ? (me.offsetHeight - extrasHeight).toFixed() : 400;
            return result;
        };

        const ps = controlHeightGenerator();

        setControlHeight(ps);
    }, [id, item.h, data]);

    return (
        <div ref={loaded} style={{ height: `${controlHeight}px` }}>
            <ResponsivePie
                data={data.map(d => {
                    return {
                        id: d.x,
                        label: SystemText(`Dashboard/Widgets/GoalsAchievedPie/${d.x}`),
                        value: d.y,
                        color: d.x === 'YES' ? 'hsl(31, 70%, 50%)' : 'hsl(186, 70%, 50%)',
                    };
                })}
                colors={['rgba(0, 166, 90, .8)', 'rgba(221, 75, 57, .8)']}
                margin={{ top: 10, right: 80, bottom: 70, left: 80 }}
                innerRadius={0.5}
                padAngle={0.7}
                cornerRadius={3}
                activeOuterRadiusOffset={8}
                borderWidth={1}
                borderColor={{
                    from: 'color',
                    modifiers: [['darker', 0.2]],
                }}
                enableArcLinkLabels={false}
                arcLabelsTextColor={'#fff'}
                legends={[
                    {
                        anchor: 'bottom',
                        direction: 'column',
                        justify: false,
                        translateX: 0,
                        translateY: 66,
                        itemsSpacing: 10,
                        itemWidth: 100,
                        itemHeight: 18,
                        itemTextColor: '#999',
                        itemDirection: 'left-to-right',
                        itemOpacity: 1,
                        symbolSize: 18,
                        symbolShape: 'circle',
                        effects: [
                            {
                                on: 'hover',
                                style: {
                                    itemTextColor: '#000',
                                },
                            },
                        ],
                    },
                ]}
                tooltip={point => (
                    <div className="chart-tooltip line">
                        <b>{point.datum.label}</b>: {point.datum.value}
                    </div>
                )}
            />
        </div>
    );
};

export default Chart;
